import React, { useState, useEffect, useRef } from 'react';
import s from './About.module.scss';
import clsx from 'clsx';
import { ReactComponent as DropDown } from 'images/new-icons/arrow-down-icon.svg';
import AboutMap from './AboutMap';

const ORDERED_DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const About = ({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const openingHours = data?.opening_hours;

  const isOpenNow = () => {
    const now = new Date();
    const day = now.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
    const time = now.getHours() * 60 + now.getMinutes();

    if (!openingHours?.[day] || !openingHours?.[day].open) return false;

    const [openHour, openMinute] = openingHours[day].open.split(':').map(Number);
    const [closeHour, closeMinute] = openingHours[day].close.split(':').map(Number);

    const openTime = openHour * 60 + openMinute;
    const closeTime = closeHour * 60 + closeMinute;

    return time >= openTime && time < closeTime;
  };

  useEffect(() => {
    const textElement = textRef.current;
    if (textElement) {
      setIsTextOverflowing(textElement.scrollHeight > textElement.clientHeight);
    }
  }, [data?.full_bio]);

  const toggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  const salonData = [
    {
      salon: {
        id: data?.id,
        latitude: data?.latitude,
        longitude: data?.longitude,
        avatar: data?.avatar,
      },
    },
  ];

  return (
    <div className={s.about}>
      <div className={s.about_info}>
        <div
          ref={textRef}
          className={`${s.about_info_text} ${isExpanded ? s.expanded : s.collapsed}`}
        >
          {data?.full_bio || 'No bio yet.'}
        </div>
        {isTextOverflowing && (
          <div className={clsx(s.about_info_view_more, s.head_text)} onClick={toggleExpand}>
            {isExpanded ? 'View Less' : 'View More'}
          </div>
        )}
      </div>
      {data?.opening_hours && (
        <div className={s.opening_hours}>
          <div className={s.opening_hours_dropdown}>
            <div className={s.head_text}>Opening Hours</div>
          </div>
        </div>
      )}
      <div className={s.opening_hours_list}>
        {ORDERED_DAYS.map(day => (
          <div key={day} className={s.opening_hours_list_item}>
            <div className={s.opening_hours_list_item_day}>{day}</div>
            <div className={s.opening_hours_list_item_time}>
              {openingHours[day]?.open && openingHours[day]?.close
                ? `${openingHours[day].open} - ${openingHours[day].close}`
                : 'Day off'}
            </div>
          </div>
        ))}
      </div>
      {data?.phone && (
        <div className={s.inf}>
          <div className={s.head_text}>Phone number</div>
          <div className={s.p_text}>{data?.phone}</div>
        </div>
      )}
      {data?.email && (
        <div className={s.inf}>
          <div className={s.head_text}>Email</div>
          <div className={s.p_text}>{data?.email}</div>
        </div>
      )}
      {data?.full_address && (
        <div className={s.inf}>
          <div className={s.head_text}>Location</div>
          <div className={s.p_text}>{data?.full_address}</div>
        </div>
      )}

      <AboutMap data={salonData} setDistances={() => {}} />

      {/* <div className={s.inf}>
        <div className={s.head_text}>Price Range</div>
        <div className={s.p_text}>$$</div>
      </div> */}
    </div>
  );
};

export default About;
